
export default function WhyChooseUs() {
  const values = [
    {
      icon: 'ri-shield-check-line',
      title: 'Garantie',
      description: 'Garantie op alle uitgevoerde werken'
    },
    {
      icon: 'ri-medal-line',
      title: 'Erkend Vakman',
      description: 'Gecertificeerde vakmensen'
    },
    {
      icon: 'ri-time-line',
      title: 'Snelle Opstart',
      description: 'Minimale wachttijden'
    },
    {
      icon: 'ri-star-line',
      title: 'Kwaliteit',
      description: 'Hoogwaardige materialen'
    }
  ];

  return (
    <section id="waarom-lba" className="py-20 bg-blue-600">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="text-white">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Kwaliteit en vakmanschap staan centraal
            </h2>
            <p className="text-blue-100 mb-8 leading-relaxed">
              Bij LBA Construct geloven we in duurzame oplossingen en een persoonlijke aanpak. We werken met hoogwaardige materialen en zorgen voor een verzorgde afwerking.
            </p>
            
            <div className="grid grid-cols-2 gap-4">
              {values.map((value, index) => (
                <div 
                  key={index}
                  className="flex items-center gap-3"
                >
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/20">
                    <i className={`${value.icon} text-lg text-white`}></i>
                  </div>
                  <span className="text-sm font-medium text-white">{value.title}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="grid grid-cols-2 gap-4">
              <img 
                src="https://static.readdy.ai/image/fc65efeb832ce485df7d40b8ca7edd24/9e72a7349eba11c2ac2720e8a89a7ed3.jpeg"
                alt="Isolatie werk"
                className="w-full h-40 object-cover object-top rounded-lg"
              />
              <img 
                src="https://public.readdy.ai/ai/img_res/26f750e421b9419a89124395e2be0a42.jpg"
                alt="Gyproc werk"
                className="w-full h-40 object-cover object-top rounded-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
